import React from "react"
import SectionHeader from "../../molecules/SectionHeader"
import TeamGallery from "../../molecules/TeamGallery"
import "./styles.scss"
const OurTeam = ({ members, teams, title, subtitle }) => {

  const displayTitle = () => {
    const numberOfMembers = members.length;
    const titleArray = title.split('team');
    return titleArray.length > 1 ?
    (<>{titleArray[0]}team<sup>{numberOfMembers}</sup>{titleArray[1]}</>)
    :
    title
  }

  return (
    <section className="section section--ourTeam">
      <div className="wrapper--text">
        <SectionHeader
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          subtitle={subtitle}
          type="h2"
        >
          {displayTitle()}
        </SectionHeader>
      </div>
      <div className="wrapper--text">
        <TeamGallery
          members={members}
          teams={teams}
        />
      </div>
    </section>
  )
}

export default OurTeam
